import { render, staticRenderFns } from "./detailShow.vue?vue&type=template&id=70c02da2&scoped=true&"
import script from "./detailShow.vue?vue&type=script&lang=js&"
export * from "./detailShow.vue?vue&type=script&lang=js&"
import style0 from "./detailShow.vue?vue&type=style&index=0&id=70c02da2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c02da2",
  null
  
)

export default component.exports